<div class="notfound-page">
    <div class="inner-container">
        <div class="message-box">
            <h1>You must be lost.</h1>
            <h3>We can't seem to find what you're looking for.</h3>
            <img src="{{this.gif}}" alt="">
        </div>
    </div>
</div>
